module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui secondary menu"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "right menu"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.tutorial
    }
  }, [_vm._v("Tutorial")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#attribution'),
      expression: "'#attribution'"
    }],
    staticClass: "ui basic button",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])])])])]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container",
    attrs: {
      "data-intro": "Welcome to the Family Birding!"
    }
  }, [_c('h1', {
    attrs: {
      "id": "masthead"
    }
  }, [_vm._v("Family Birding!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58962b26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyMenu.vue
// module id = 239
// module chunks = 1